import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export interface NavigationTreeDataDTO {
  childTypes: NavigationTreeChildDTO[];
  parentLabelTranslation: string;
  parentPosition: number;
  parentType: string;
  parentTypeTranslation: string;
  enabledParent: boolean;
}

export interface NavigationTreeChildDTO {
  type: string;
  typeTranslation: string;
  position: number;
  enabled: boolean;
}

export interface NotificationManagementTreeResponseDTO {
  nodes?: Array<Omit<NavigationTreeDataDTO, "childTypes"> & { childTypes?: NavigationTreeChildDTO[] }>;
}

export async function getNavigationTree(): Promise<NavigationTreeDataDTO[]> {
  const url = occUrl("/notifications/navigation-tree");

  const response = await occFetch(url);

  const root = (await response.json()) as NotificationManagementTreeResponseDTO;
  const dto: NavigationTreeDataDTO[] = (root.nodes ?? []).map((node) => ({
    ...node,
    childTypes: node.childTypes ?? [],
  }));

  if (dto[0]) {
    dto[0].childTypes = [];
  }

  return dto;
}
